import React from 'react'
import log from "../../assets/images/log.png"
import comLogoWhite from "../../assets/images/comLogoWhite.svg"
import { Link } from 'react-router-dom'
import { COMMBITZ_URL } from '../../config'
import styles from "./style/style.module.css"
import FooterContainer from './FooterContainer'
import CopyRight from './CopyRight'

function Footer() {
    return (

        <footer>
            <div className={styles.footerMain}>
                <div className="container-fluid">
                <FooterContainer />
                <CopyRight />
                </div>
            </div>
            {/* <span className={styles.nextPage}> <Link to={generateWhatsAppLink()} target="_blank" rel="noopener noreferrer" > <Image width="25" height="25" src={wts} alt=""/></Link></span> */}
            </footer>

    )
}

export default Footer